<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <GrupoForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import GrupoForm from "../../../components/forms/GrupoForm.vue";
import { GrupoService } from "../../../services/GrupoService";

export default {
  name: "CriarGrupo",
  components: {
    Breadcrumb,
    GrupoForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Início",
          disabled: false,
          href: "/"
        },
        {
          text: "Grupos",
          disabled: false,
          href: "/grupos"
        },
        {
          text: "Criar Grupo",
          disabled: true,
          href: "/grupos/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_grupo", formData.codigo_grupo);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await GrupoService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de grupos após salvar
          this.$router.push('/gerenciar-grupos');
        } else {
          throw new Error('Erro ao criar grupo');
        }
      } catch (error) {
        console.error('Erro ao criar grupo:', error);
        // O componente GrupoForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-grupos');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>